import { CoreIcon } from '../core-icon';
import arrowLeftCircleSVG from '../../assets/icons/arrow-left-circle.svg';
import type { IconProps } from '../core-icon';

export const ArrowLeftCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={arrowLeftCircleSVG} {...props} />;
};
